import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { InstanceService, ZoningCodeService } from 'src/app/modules/instance/services';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';

import IZoningCodeCalculationStatistic = ZoningAPI.IZoningCodeCalculationStatistic;
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ZCVersionDetailsViewComponent } from '../../entity-details-view/zc-version-details-view/zc-version-details-view.component';
import { ZCVCalcProcessDetailsViewComponent } from '../../../process-details-view/zcv-calc-process-details-view/zcv-calc-process-details-view.component';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-check-status-button',
    templateUrl: './zoning-code-version-check-status-button.component.html',
    styleUrls: ['./zoning-code-version-check-status-button.component.scss']
})
export class zoningCodeVersionCheckStatusButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        private readonly instanceService: InstanceService,
        private readonly dialog: MatDialog
    ) {
        super();
    }

    isOpenDialog = false;

    @Input()
    zoningCode: ZoningCode;

    @Input()
    zoningCodeVersion: ZoningCodeVersion;

    @Input()
    openDialog: boolean;

    @Input()
    isOpen: boolean;

    @Input()
    isLoaded: boolean;

    @Input()
    stateEnv?: string;

    @Output()
    isLoadedChange = new EventEmitter<boolean>();

    @Output()
    isLoadedVersionDialog = new EventEmitter<boolean>();

    openTaskInfoDialog(
        zoningCodeVersion: ZoningCodeVersion,
        tasks: ITaskModel | IZoningCodeCalculationStatistic,
        component
    ) {
        if (!tasks) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = { zcVersionStatistic: tasks, zoningCodeVersion, stateEnv: this.stateEnv };
        dialogConfig.maxHeight = '650px';
        dialogConfig.width = '800px';

        this.dialog.open(component, dialogConfig);
        this.isOpenDialog = false;
    }

    async getZCVersionStatistics(event: Event) {
        if (this.isOpenDialog) {
            return;
        }
        this.isOpenDialog = true;
        event.stopPropagation();
        this.isLoadedVersionDialog.emit(true);
        if (this.isOpen) {
            this.isLoaded = false;
            this.isLoadedChange.emit(false);
        }

        await this.zoningCodeService.checkZCVersion(this.zoningCode, this.zoningCodeVersion, this.stateEnv).toPromise();

        if (!this.zoningCodeVersion.hasTasks) {
            await this.zoningCodeService
                .getZoningCodeCalculationStatistic(this.zoningCode, this.zoningCodeVersion, this.stateEnv, true, true)
                .subscribe(() => {
                    if (this.isOpen) {
                        this.isLoaded = true;
                        this.isLoadedChange.emit(true);
                    }

                    if (this.openDialog) {
                        this.openTaskInfoDialog(
                            this.zoningCodeVersion,
                            this.zoningCodeVersion.Statistic[0],
                            ZCVersionDetailsViewComponent
                        );
                    }
                    this.isLoadedVersionDialog.emit(false);
                });
        } else {
            if (this.isOpen) {
                this.isLoaded = true;
                this.isLoadedChange.emit(true);
            }

            if (this.openDialog) {
                this.openTaskInfoDialog(
                    this.zoningCodeVersion,
                    this.zoningCodeVersion.Tasks[0],
                    ZCVCalcProcessDetailsViewComponent
                );
            }
            this.isLoadedVersionDialog.emit(false);
        }

        this.instanceService.updateSelectedInstanceStatistic();
    }
}
